import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import SwornTranslatorProductPage from "@/components/SwornTranslatorProductPage";
import { swornProductGraph, defaultSwornProductFaqs } from "@/lib/sworn-translator-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/en/sworn-translator/products/$slug")({
  loader: async ({ params }) => {
    const { getSwornProduct } = await import("@/data/sworn-translator-products");
    const p = getSwornProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("Not found", "/en/sworn-translator/products/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/en/sworn-translator/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `Sworn Translation of ${p.nameEn} — Thailand | ${p.turnaround}`;
    const desc = p.shortDescEn + " · MoJ-registered Thai translator + destination sworn-translator network (DE/FR/ES/IT/NL/PL) · Bundle notary + MFA + Apostille under one roof.";
    const faqs = defaultSwornProductFaqs(p, "en");
    return {
      meta: [
        { title: ctaTitle(title, "/en/sworn-translator/products/$slug", "en") }, { name: "description", content: ctaDesc(desc, "/en/sworn-translator/products/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/sworn-translator/products/$slug", "en")},
        { property: "og:description", content: ctaDesc(desc, "/en/sworn-translator/products/$slug", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "en_US" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${BRAND_URL}/sworn-translator/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: `${BRAND_URL}/sworn-translator/products/${params.slug}` },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(swornProductGraph({ product: p, locale: "en", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">Service not found</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <SwornTranslatorProductPage product={product} locale="en" faqs={defaultSwornProductFaqs(product, "en")} />;
  },
});
